
import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import Sidebar from './../Sidebar/index.vue'; // Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import CreateThread from '../CreateThread.vue';
let service = new services();

export default {
    name: 'Forums',
    data () {
        return {
            forums: {},
            forum: {},
            panelFlag: false,
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            search_forum: 0,
            current_page: 0,
            loggedIn: false,
        }
    },
    metaInfo() {
        return{
            title: "Discussions on cityneeds forum",
            titleTemplate: '',
            meta: [
                { 'property': 'og:description', 'content': 'Discussions on cityneeds forum, my opinion counts, cityneeds, abuja, nigeria africa', 'vmid': 'og:description' }
              ],
        }
    },
    components: {
        'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter,      
        'create-thread': CreateThread
    },
    methods:{
        //component 
        setComponent(component) {
            this.forum = component;
            this.panelFlag = true;
                  
        },
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },

        setForumDsc(text){
            let p_fmttd = "";
           // var text=document.getElementById("url").value;
            var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
            var text1 = text.replace(exp, "<a href='$1'>$1</a>");
            var exp2 =/(^|[^\/])(www\.[\S]+(\b|$))/gim;

            p_fmttd =text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');

            return p_fmttd;
        },

        setForum(forum){
            localStorage.setItem("cn_f",forum);
            this.$router.push("/forum");
        },

        getAllForums(offset,items) {
           service.getForums(this,offset,items).then(data => {
               if(data.body.status == 200) {
                    this.forums = data.body.data;
                    // this.forums.count_range = Math.floor(data.body.data_count/5);
                    if((data.body.data_count % this.pag_intv)){
                        this.forums.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                    }else{this.forums.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                    this.current_page = items;
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getForums(offset,items) {
            service.getForums(this,this.search_forum,offset,items).then(data => {
                if(data.body.status == 200) {
                     this.forums = data.body.data;
                     // this.forums.count_range = Math.floor(data.body.data_count/5);
                     if((data.body.data_count % this.pag_intv)){
                         this.forums.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                     }else{this.forums.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                    // this.current_page = items; //rethought
                    if(offset == 0){//ist page
                        this.current_page = 1;
                    }else{
                        this.current_page = items; //and we are back!
                    }
                 }
             }).catch((err) => {
                 if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
         },
 
        
        //fmr
        searchForums() {
            if(this.search_forum != 0){
                service.searchForums(this,this.search_forum).then(data => {
                    if(data.body.status == 200) {
                         this.forums = data.body.data;
                     }
                 }).catch((err) => {
                     if(err) {
                         //toastr.error('Sorry, could not process information', 'Warning!');
                     }
                 })
            }else{
                this.getAllForums(0,this.pag_intv);
            }
        },

       

        checkLoggedIn(){
            // if(localStorage.getItem("cityneeds_token") != null) {
            if(localStorage.getItem("cityneeds_token")) {
                this.loggedIn = true
            }
        }
    },
    created: function(){
        // this.getAllForums(0,this.pag_intv);
        this.getForums(0,this.pag_intv);
        //login check
        this.checkLoggedIn();
    }
}


// WEBPACK FOOTER //
// ./src/components/Forums/script.js